// Custom helper functions

export const rolesPerPage = 3